module.exports = __webpack_public_path__ + "static/media/bold.7ad9e5c5.svg";